<template>
  <div id="box">
    <n-form :model="formData" size="medium" label-placement="left">
      <n-grid :col="24" :x-gap="24">
        <n-form-item-gi :span="8" label="异常方案名称">
          <n-input v-model:value="formData.name" placeholder="请输入异常方案" />
        </n-form-item-gi>
        <n-form-item-gi :span="8" label="日期">
          <el-date-picker
            v-model="formData.beforeTime"
            type="date"
            placeholder="请选择日期"
          />
          <span style="margin-left: 5px">-</span>
          <el-date-picker
            v-model="formData.afterTime"
            type="date"
            placeholder="请选择日期"
            style="margin-left: 5px"
          />
        </n-form-item-gi>
        <n-form-item-gi :span="4">
          <n-button
            type="info"
            size="medium"
            @click="search(formData, (currentPage = 1))"
          >
            查询
          </n-button>
          <n-button
            type="info"
            @click="cleanForm()"
            size="medium"
            style="margin-left: 20px"
            ghost
          >
            重置
          </n-button>
        </n-form-item-gi>
        <n-form-item-gi :span="24">
          <n-button type="info" size="medium" @click="add()"> 新增 </n-button>
          <n-button
            type="info"
            size="medium"
            @click="deleteAll()"
            style="margin-left: 10px"
          >
            批量删除
          </n-button>
          <n-button
            type="info"
            size="medium"
            @click="dataExport(tableData)"
            style="margin-left: 10px"
          >
            导出
          </n-button>
        </n-form-item-gi>
      </n-grid>
    </n-form>
    <div class="select-num" v-if="selectNum !== 0">
      <div class="select-num-content">
        <span
          >已选择<span
            style="color: #409eff; margin-left: 1px; margin-right: 1px"
            >{{ selectNum }}</span
          >项</span
        >
        <el-link type="primary" style="margin-left: 20px" @click="cleanSelect"
          >清空</el-link
        >
      </div>
    </div>
    <el-table
      :data="tableData"
      ref="tableRef"
      style="width: 100%; margin-bottom: 20px; margin-top: 10px"
      empty-text="暂无数据"
      row-key="id"
      size="large"
      border
      @selection-Change="handSelectChange"
      max-height="449"
    >
      <el-table-column
        fixed="left"
        type="selection"
        label="状态"
        width="60"
        align="center"
      />
      <el-table-column
        fixed="left"
        prop="id"
        :label="label[0]"
        width="70"
        align="center"
      />
      <el-table-column
        prop="name"
        :label="label[1]"
        min-width="95"
        align="center"
      />
      <el-table-column
        prop="balance"
        :label="label[2]"
        min-width="140"
        align="center"
      />
      <!-- <el-table-column
        prop="powerAlarm"
        :label="label[3]"
        min-width="150"
        align="center"
      /> -->
      <el-table-column
        prop="type"
        :label="label[4]"
        min-width="150"
        align="center"
      />
      <el-table-column
        prop="content"
        :label="label[5]"
        min-width="100"
        align="center"
      />
      <el-table-column
        prop="time"
        :label="label[6]"
        min-width="180"
        align="center"
      />
      <el-table-column
        fixed="right"
        :label="label[7]"
        width="200"
        align="center"
      >
        <template #default="{ row }">
          <el-link type="primary" @click="edit(row)">编辑</el-link>
          <el-link type="danger" style="margin-left: 10px" @click="Delete(row)"
            >删除</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-left: 250px; margin-top: 50px"
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :small="small"
      :disabled="disabled"
      :background="background"
      layout="total, prev, pager, next, jumper"
      :total="tableInfo.total"
      pager-count="9"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";
import {
  ElMessage,
  ElTable,
  ElTableColumn,
  ElLink,
  ElPagination,
  ElMessageBox,
  ElInput,
  ElCard,
  ElDatePicker,
} from "element-plus";
import axios from "axios";
export default defineComponent({
  components: {
    ElTable,
    ElTableColumn,
    ElLink,
    ElPagination,
    ElMessageBox,
    ElInput,
    ElCard,
    ElDatePicker,
  },
  setup() {
    // 表单信息
    const formData = ref({
      name: "",
      selectOption: [],
    });
    let isLoading = ref(false);
    let dialogShow = ref(false);
    let rowInfo = ref({});
    let title = ref("");
    let isSearch = ref(false);
    // 查询
    const search = (form, index) => {
      if (
        formData.value.beforeTime > date.getTime() ||
        formData.value.afterTime > date.getTime()
      ) {
        ElMessage({
          message: "未来的信息不可查询！",
          type: "error",
        });
      } else if (formData.value.beforeTime > formData.value.afterTime) {
        ElMessage({
          message: "第一个日期应小于等于第二个日期！",
          type: "warning",
        });
      } else {
        typeof form === "undefined" ? "" : form;
        form.afterTime === null ? "" : form.afterTime;
        form.beforeTime === null ? "" : form.beforeTime;
        isLoading = true;
        isSearch.value = true;
        let result = axios({
          method: "post",
          url:
            "http://water.chorizon.top:8085/scenariosManager/query?name=" +
            (typeof form.name === "undefined" ? "" : form.name) +
            "&beforeTime=" +
            (typeof form.beforeTime === "undefined" || form.beforeTime === null
              ? ""
              : form.beforeTime.getFullYear() +
                "-" +
                (form.beforeTime.getMonth() + 1) +
                "-" +
                form.beforeTime.getDate()) +
            "&afterTime=" +
            (typeof form.afterTime === "undefined" || form.afterTime === null
              ? ""
              : form.afterTime.getFullYear() +
                "-" +
                (form.afterTime.getMonth() + 1) +
                "-" +
                form.afterTime.getDate()) +
            "&pageNum=" +
            (typeof index === "undefined" ? "" : index),
          dataType: "jsonp",
          jsonp: "callback",
          jsonpCallback: "f",
        });
        result
          .then((res) => {
            if (res.data.code === 200) {
              tableData.value = res.data.data.records;
              tableInfo.value = res.data.data;
              isLoading = false;
            }
            console.log(res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    };
    // 重置表单
    const cleanForm = () => {
      formData.value.name = "";
    };

    // 表格信息
    const tableData = ref([
      {
        id: "1",
        errorFunName: "异常告警",
        balanceAlarm: "57",
        powerAlarm: "100",
        waterAlarm: "10",
        other: "--",
        updateTime: "2021-01-14 23:23:38",
      },
      {
        id: "2",
        errorFunName: "异常告警",
        balanceAlarm: "57",
        powerAlarm: "100",
        waterAlarm: "10",
        other: "--",
        updateTime: "2021-01-14 23:23:38",
      },
      {
        id: "3",
        errorFunName: "异常告警",
        balanceAlarm: "57",
        powerAlarm: "100",
        waterAlarm: "10",
        other: "--",
        updateTime: "2021-01-14 23:23:38",
      },
    ]);

    // 表格标签信息
    const label = ref([
      "序号",
      "方案名称",
      "余额报警（元）",
      "用电报警（kWh）",
      "用水报警（m2）",
      "备注",
      "更新时间",
      "操作",
    ]);

    // 选择项的个数
    const selectNum = ref(0);
    // 表格数据绑定
    const tableRef = ref();

    // 清空选项
    const cleanSelect = () => {
      tableRef.value.clearSelection();
    };

    // 选择选项后触发的事件
    const handSelectChange = (selection) => {
      selectNum.value = selection.length;
      formData.selectOption = selection;
    };

    // 声明date获取时间
    const date = new Date();

    // 新增功能
    const add = () => {
      title.value = "新增";
      rowInfo.value = {};
      dialogShow.value = true;
      // ElMessage("新增功能正在研发中！");
    };

    // 批量删除
    const deleteAll = () => {
      ElMessageBox.confirm("你确定批量删除信息吗?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        formData.selectOption.forEach((ele) => {
          axios({
            method: "post",
            url:
              "http://water.chorizon.top:8085/scenariosManager/delete?id=" +
              ele.id,
            dataType: "jsonp",
            jsonp: "callback",
            jsonpCallback: "f",
          });
        });
        ElMessage("已被删除");
      });
      // ElMessage("批量删除功能正在研发中！");
    };

    // 导出功能
    const dataExport = (jsonData) => {
      // 列标题，逗号隔开，每一个逗号就是隔开一个单元格
      let str = `序号,方案名称,余额报警（元）,用电报警（kWh）,用水报警（m2）,备注,更新时间\n`;
      // 增加\t为了不让表格显示科学计数法或者其他格式
      for (let i = 0; i < jsonData.length; i++) {
        for (const key in jsonData[i]) {
          str += `${jsonData[i][key] + "\t"},`;
        }
        str += "\n";
      }
      // encodeURIComponent解决中文乱码
      const uri =
        "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str);
      // 通过创建a标签实现
      const link = document.createElement("a");
      link.href = uri;
      // 对下载的文件命名
      link.download =
        "计价档案_" +
        date.getFullYear() +
        "-" +
        date.getMonth() +
        1 +
        "-" +
        date.getDate() +
        ".csv";
      link.click();
    };

    // 编辑
    const edit = (row) => {
      title.value = "编辑";
      rowInfo.value = row;
      dialogShow.value = true;
      // ElMessage("编辑功能正在研发中！");
    };

    // 删除
    const Delete = (row) => {
      ElMessageBox.confirm("你确定删除" + row.name + "的信息吗?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios({
            method: "post",
            url:
              "http://water.chorizon.top:8085/scenariosManager/delete?id=" +
              row.id,
            dataType: "jsonp",
            jsonp: "callback",
            jsonpCallback: "f",
          });
          ElMessage(row.name + "已被删除");
        })
        .catch(() => {
          ElMessage("删除失败");
        });
    };

    // 表头样式
    const tableHeadStyle = ({ row, column, rowIndex, columnIndex }) => {
      return {
        backgroundColor: "#f4f4f5",
        color: "#606266",
      };
    };
    const select = (selection, row) => {
      tableRowStyle(row);
    };
    // 表格样式
    const tableRowStyle = ({ row, column, rowIndex, columnIndex }) => {
      // if(row.other === '--'){
      //     return {
      //         fontSize: '15px',
      //     }
      // }else{
      //     return {
      //         color: '#909399',
      //     }
      // }
    };

    // 分页器
    const currentPage = ref(1);
    const pageSize = ref(10);
    const small = ref(false);
    const background = ref(true);
    const disabled = ref(false);
    let tableInfo = ref({});

    function handleSizeChange() {}
    function handleCurrentChange(index) {
      search(formData, index);
      // getErrorFunList(index);
    }
    const getErrorFunList = async function (index) {
      let res = await getErrorFunListData({ pageSize: 3, pageNum: index });
      console.log(res);
      if (res.code === 200) {
        tableData.value = res.data.records;
        tableInfo.value = res.data;
      }
    };
    onMounted(() => {
      search("");
      // getErrorFunList(currentPage.value);
    });

    return {
      currentPage,
      pageSize,
      background,
      small,
      disabled,
      handleSizeChange,
      handleCurrentChange,
      formData,
      tableData,
      tableInfo,
      label,
      selectNum,
      tableRef,
      cleanSelect,
      search,
      cleanForm,
      dataExport,
      add,
      deleteAll,
      edit,
      Delete,
      isLoading,
      tableHeadStyle,
      tableRowStyle,
      select,
      handSelectChange,
      dialogShow,
      rowInfo,
      title,
    };
  },
});
</script>

<style lang="scss">
#box {
  width: 90%;
  margin: 10px auto;
  .select-num {
    background-color: #d9ecff;
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 10px;
    border: 2px #c6e2ff solid;
    box-sizing: border-box;
    .select-num-content {
      margin-left: 20px;
    }
  }
}
</style>